import { SVGAttributes } from 'react';

type IconProps = SVGAttributes<SVGElement>;

const CloseIcon = ({ color = 'currentColor', ...svgProps }: IconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00001 17.6981L17.7745 4.00004L20 6.302L6.2255 20L4.00001 17.6981Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8936 17.698L6.38747 4.00002L4.13977 6.27966L17.6459 19.9777L19.8936 17.698Z"
        fill={color}
      />
    </svg>
  );
};

export default CloseIcon;
